import { store } from '@/decorators/store';
import { CancellationReason } from '@/entities/CancellationReason';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'CancellationReason' })
export class CancellationReasonStore extends AbstractEntityStore<CancellationReason> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
